
const EmailTypeEnum = {
  InvitationTickets: 'invitationtickets',
  Invitation: 'invitation',
  ReminderTickets: 'remindertickets',
  Reminder: 'reminder',
  ConfirmationTicketsSelfBuy: 'confirmationticketsselfbuy',
  Confirmation: 'confirmation',
  ConfirmationTicketsOthersBuy: 'confirmationticketsothersbuy',
  ReminderCompleteRegistration: 'remindercompleteregistration',
  ConfirmationTickets: 'confirmationtickets',
  Custom: 'custom',
  AssignTickets: 'assignticket',
  ResendTickets: 'resendticket',
};

export default Object.freeze(EmailTypeEnum);
